import { get } from "../../service/api";

const GetInvoiceEventLogs = async (queryString) => {
  try {
    const response = await get(`/invoice/eventLog?1=1${queryString}`);
    return response;
  } catch (error) {
    console.error("Error GetInvoiceEventLogs:", error);
    throw error;
  }
};

export default GetInvoiceEventLogs;
